import { combineReducers } from '@reduxjs/toolkit';
import advancedSearchPanel from './advancedSearchSlice';

const reducer = combineReducers({
   advancedSearchPanel,
});

export default reducer;
